import { defineCustomElement } from '@tyler-components-web/core';
import { BannerComponent } from './banner';
export * from './banner-adapter';
export * from './banner-constants';
export * from './banner-foundation';
export * from './banner';
export function defineBannerComponent() {
    defineCustomElement(BannerComponent);
}
